<template>
  <main class="privacy-policy">
    <vx-card class="content-wrapper w-11/12 2 md:w-4/5 lg:w-2/3 m-auto px-3 md:px-6 lg:px-12">
      <div class="image-wrapper flex justify-center">
        <img src="logo.png" alt="graphic-404" class="w-24" >
      </div>
      <h1 class="my-5 text-center font-semibold">{{data.name}}</h1>
      <div class="content mt-10" v-html="data.description"></div>
    </vx-card>
  </main>
</template>

<script>
export default {
  data() {
    return {
      data: {}
    }
  },
  created() {
    this.$axios.get('/misc/pages/privacy-policy').then(res => {
      this.data = res.data.data
    })
  }
}
</script>

<style>
.privacy-policy {
    background-image: url("../../assets/images/pages/vuexy-login-bg.jpg");
    height: 100vh;
    overflow: hidden;
    display: grid;
    place-items: center;
}
.privacy-policy .content-wrapper {
  height: 95vh;
  overflow: auto;
}
.privacy-policy .content-wrapper::-webkit-scrollbar{
    width: 3px !important;
    height: 3px !important;
}
.privacy-policy .content-wrapper::-webkit-scrollbar-thumb{
    background-color: lightgray;
}
</style>